import { RefObject, useCallback, useState } from "react"

interface UsePdfExportOptions {
  filename?: string
  pageSize?: "a4" | "letter"
}

function usePdfExport(
  contentRef: RefObject<HTMLElement>,
  options: UsePdfExportOptions = {}
) {
  const [isPending, setIsPending] = useState(false)

  const exportToPdf = useCallback(async (title: string) => {
    if (!contentRef.current) return

    setIsPending(true)

    try {
      const html2pdf = (await import("html2pdf.js")).default

      const element = contentRef.current
      const filename = options.filename || `${title.replace(/\s+/g, "-").toLowerCase()}.pdf`

      const opt = {
        margin: [10, 10, 10, 10],
        filename,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          logging: false,
          ignoreElements: (el: Element) => {
            return el.classList.contains("help-center-header__actions")
          }
        },
        jsPDF: {
          unit: "mm",
          format: options.pageSize || "a4",
          orientation: "portrait"
        },
        pagebreak: { mode: ["avoid-all", "css", "legacy"] }
      }

      await html2pdf().set(opt).from(element).save()
    } catch (error) {
      console.error("PDF export failed:", error)
    } finally {
      setIsPending(false)
    }
  }, [contentRef, options.filename, options.pageSize])

  return {
    exportToPdf,
    isPending
  }
}

export default usePdfExport
